"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const unknown_status_code_exception_1 = require("./exceptions/unknown-status-code-exception");
const types_1 = require("./types");
function inferStatusClass(statusCode) {
    if (statusCode >= 100 && statusCode <= 199) {
        return types_1.StatusClass.Informational;
    }
    if (statusCode >= 200 && statusCode <= 299) {
        return types_1.StatusClass.Successful;
    }
    if (statusCode >= 300 && statusCode <= 399) {
        return types_1.StatusClass.Redirection;
    }
    if (statusCode >= 400 && statusCode <= 499) {
        return types_1.StatusClass.ClientError;
    }
    if (statusCode >= 500 && statusCode <= 599) {
        return types_1.StatusClass.ServerError;
    }
    throw new unknown_status_code_exception_1.UnknownStatusCodeException(statusCode);
}
exports.inferStatusClass = inferStatusClass;
//# sourceMappingURL=infer-status-class.js.map